export default "__VITE_ASSET__4c36a90e__"